import React, { useContext, useEffect, useState } from "react";
import Hero from "./Hero";
import SearchComponent from "./searchComponent";
import menu from "../../assets/images/mains-logo.png";
import cartIcon from "../../assets/images/open-cart-icon.png";
import { Modal, ModalBody } from "reactstrap";
import Carousel from "react-multi-carousel";
import "../../assets/css/--page-menu.css";
import { addCart, addWishlist, getParentCategory, getProductListByCategoryId } from "../../helper/backend-methods";
import AppLoader from "../../components/AppLoader";
import { customToast } from "../../components/customToast";
import { useCart } from "../../context/cartProvider";
import { GlobalContext } from "../../context";
import ProductCustomizationModal from "../../components/ProductCustomizationModal";
import { useSearchParams } from "react-router-dom";

const CATEGORY_SLIDER_BREAKPOINT = 775;

const CustomLeftArrow = ({ onClick, disabled }) => (
  <button className="custom-arrow left" onClick={onClick} disabled={disabled} type="button" aria-label="Previous categories">
    <i className="ri-arrow-left-s-line"></i>
  </button>
);

const CustomRightArrow = ({ onClick, disabled }) => (
  <button className="custom-arrow right" onClick={onClick} disabled={disabled} type="button" aria-label="Next categories">
    <i className="ri-arrow-right-s-line"></i>
  </button>
);

const categoryCarouselResponsive = {
  tablet: { breakpoint: { max: 775, min: 668 }, items: 3.3, partialVisibilityGutter: 10 },
  mobile: { breakpoint: { max: 668, min: 485 }, items: 2.4, partialVisibilityGutter: 10 },
  mobileSmall: { breakpoint: { max: 485, min: 0 }, items: 1.6, partialVisibilityGutter: 10 },
};

export default function MenuPage() {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("categoryId");
  const section = searchParams.get("section");
  const itemName = searchParams.get("item");
  const [activeCategory, setActiveCategory] = useState(0);
  const [categories, setCategories] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { openCart } = useCart();
  const { cartCount, updateCartCount, products, query, updateCartDrawer } = useContext(GlobalContext);
  const [categoryName, setCategoryName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isCategorySlider, setIsCategorySlider] = useState(window.innerWidth <= CATEGORY_SLIDER_BREAKPOINT);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsCategorySlider(window.innerWidth <= CATEGORY_SLIDER_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const accessToken = localStorage.getItem("authToken");
    setAuthorized(!!accessToken && accessToken.length > 0);
  }, []);

  const handleProductClick = (product) => {
    const hasCustomizations = product.productAttributes && product.productAttributes.length > 0;

    const productWithDefaults = {
      ...product,
      SelectedAddons: [],
      totalPrice: product.Price || 0,
    };

    if (hasCustomizations) {
      setSelectedProduct(productWithDefaults);
      setIsModalOpen(true);
    } else {
      addCart({
        Products: [
          {
            ProductId: product.ProductId,
            Quantity: 1,
            AttributesXml: null,
          },
        ],
      })
        .then(({ data }) => {
          if (data.Status) {
            customToast.success("Added to Cart", "Your item has been successfully added.", "/openCart");
            updateCartCount({
              CartItemCount: data.Data.CartItemCount,
              TotalAmount: data.Data.TotalAmount,
            });
            updateCartDrawer();
          }
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          customToast.error("Error", "Failed to add item to cart.");
        });
    }
  };

  const getParentCategories = () => {
    getParentCategory()
      .then(({ data }) => {
        if (data.Status) {
          setCategories(data.Data);
          if (!categoryId && !section) {
            getMenuItemsByCategory(data.Data[0].CategoryId, data.Data);
            setCategoryName(data.Data[0].CategoryName);
          }
        }
      })
      .catch((err) => {
        setCategories([]);
        console.error("Error fetching categories:", err);
      });
  };

  const getMenuItemsByCategory = (categoryId, categoriesData = categories) => {
    setLoading(true);
    setActiveCategory(categoryId);
    const selectedCat = categoriesData.find((cat) => cat.CategoryId === categoryId);
    setCategoryName(selectedCat ? selectedCat.CategoryName : "");
    getProductListByCategoryId({ categoryId: categoryId })
      .then(({ data }) => {
        if (data.Status) {
          setMenuItems(data.Data);
          if (section && itemName) {
            const item = data.Data.find((prod) => prod.ProductName.toLowerCase().replace(/\s/g, "") === itemName.toLowerCase());
            if (item) {
              handleProductClick(item);
            }
          }
        } else {
          setMenuItems([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        setMenuItems([]);
        setLoading(false);
      });
  };

  const addProductToWishList = (item, isAdd) => {
    addWishlist({ Add: isAdd, ProductId: item.ProductId }).then(({ data }) => {
      if (data.Status) {
        if (!isAdd) {
          customToast.info("Item Removed from Wishlist", "You can add it back anytime from the menu.");
        } else {
          customToast.wish(
            "Item Saved to Your Wishlist",
            "You can view it anytime in your wishlist. Don’t miss it when it’s back or on special!",
          );
        }
      }
      setMenuItems((prev) => prev.map((i) => (i.ProductId === item.ProductId ? { ...i, IsWishlist: isAdd } : i)));
    });
  };

  useEffect(() => {
    if (products.length > 0) {
      setLoading(true);
      setActiveCategory("");
      setCategoryName("Search Result for " + query);
      setMenuItems(products);
      setLoading(false);
    }
  }, [products]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getParentCategories();
  }, []);

  useEffect(() => {
    if (categoryId && categories.length > 0) {
      const numericCategoryId = parseInt(categoryId);
      const categoryExists = categories.some((cat) => cat.CategoryId === numericCategoryId);

      if (categoryExists) {
        getMenuItemsByCategory(numericCategoryId);
      }
    } else if (section && itemName && categories.length > 0) {
      const category = categories.filter((cat) => cat.CategoryName.toLowerCase().replace(/\s/g, "") === section.toLowerCase());
      if (category && category.length > 0) {
        getMenuItemsByCategory(category[0].CategoryId);
      }
    } else if (section && categories.length > 0) {
      const category = categories.filter((cat) => cat.CategoryName.toLowerCase().replace(/\s/g, "") === section.toLowerCase());
      if (category && category.length > 0) {
        getMenuItemsByCategory(category[0].CategoryId);
      }
    }
  }, [categoryId, categories]);

  return (
    <div className="menu-page">
      <Hero />
      <div className="wrapper">
        <SearchComponent allItems={menuItems} />

        <div className="menu-layout">
          {/* LEFT SIDEBAR */}
          <div>
            <div className="categories-hd">Categories</div>
            <div className="menu-categories">
              {isCategorySlider ? (
                <Carousel
                  responsive={categoryCarouselResponsive}
                  arrows
                  partialVisible
                  infinite={false}
                  containerClass="menu-categories-carousel"
                  itemClass="menu-categories-carousel-item"
                  customLeftArrow={<CustomLeftArrow />}
                  customRightArrow={<CustomRightArrow />}
                >
                  {categories.map((cat) => (
                    <div
                      key={cat.CategoryId}
                      className={`category-item ${activeCategory === cat.CategoryId ? "active" : ""}`}
                      onClick={() => getMenuItemsByCategory(cat.CategoryId)}
                    >
                      <img
                        src={cat.CategoryPicture.PictureId > 0 ? cat.CategoryPicture?.Url : menu}
                        className="category-icon"
                        alt={cat.CategoryName}
                      />
                      <span className="menu-name">{cat.CategoryName}</span>
                    </div>
                  ))}
                </Carousel>
              ) : (
                categories.map((cat) => (
                  <React.Fragment key={cat.CategoryId}>
                    <div
                      className={`category-item ${activeCategory === cat.CategoryId ? "active" : ""}`}
                      onClick={() => getMenuItemsByCategory(cat.CategoryId)}
                    >
                      <img
                        src={cat.CategoryPicture.PictureId > 0 ? cat.CategoryPicture?.Url : menu}
                        className="category-icon"
                        alt={cat.CategoryName}
                      />
                      <span className="menu-name">{cat.CategoryName}</span>
                    </div>
                    <span className="separator" />
                  </React.Fragment>
                ))
              )}
            </div>
          </div>

          {/* RIGHT MENU */}
          <div className="menu-content">
            <h2 className="menu-content-title">{categoryName}</h2>
            {loading ? (
              <div className="loading-container" style={{ marginTop: "100px" }}>
                <AppLoader />
              </div>
            ) : (
              <div className="menu-grid">
                {menuItems.length === 0 && !loading ? (
                  <div className="no-menu-items">No menu items available in this category.</div>
                ) : (
                  menuItems.map((item) => (
                    <div className="menu-card" key={item.ProductId}>
                      {item.IsTodaySpecial && <span className="special-badge-menu">🔥 Today's Special</span>}
                      {authorized && (item.IsWishlist ? (
                        <button className="heart-btn" onClick={() => addProductToWishList(item, false)}>
                          <i className="ri-heart-fill"></i>
                        </button>
                      ) : (
                        <button className="heart-btn-outline" onClick={() => addProductToWishList(item, true)}>
                          <i className="ri-heart-line"></i>
                        </button>
                      ))}
                      <div className="menu-body">
                        <div className="menu-info">
                          <h3 className="menu-title">{item.ProductName}</h3>
                          <p>{item.ShortDescription}</p>
                        </div>
                       <div>
                         <img
                          src={item.ProductPictures[0]?.PictureId > 0 ? item.ProductPictures[0]?.Url : menu}
                          alt={item.ProductName}
                          className="menu-img"
                        />
                       </div>
                      </div>

                      <div className="menu-footer">
                        <span className="price">${item.Price.toFixed(2)}</span>
                        <button onClick={() => handleProductClick(item)} type="button" className="btn">
                          <span className="plus-icon">+</span>
                          ORDER NOW
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <ProductCustomizationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        product={selectedProduct}
        toastLink="/openCart"
      />
      {/* FIXED VIEW CART BAR */}
      <div className="fixed-cart-bar" onClick={openCart}>
        <img src={cartIcon} />
        <div className="cart-center">
          <span className="cart-text">View Cart</span>
          <span className="cart-count">{cartCount.CartItemCount || 0}</span>
        </div>
        <div className="cart-price">${parseFloat(cartCount.TotalAmount || 0).toFixed(2) || 0}</div>
      </div>
    </div>
  );
}
